export enum CategoryName {
  DIVIDENS = 'modificari-legislative',
  TVA = 'resurse-legislative',
  CHECKOUT = 'ghiduri-practice',
}

export type CategoryTpe = {
  name: CategoryName;
  label: string;
};

export type CategoriesType = Array<CategoryTpe>;

export type LegacyDataType = {
  id: string;
  title: string;
  body: string;
  excerpt: string;
  updated_at?: Date | string;
};

export type LegacyResponseType = {
  data: LegacyDataType[];
  links: { next: string | null; prev: string | null };
};

export type LegacyHomeResponseType = Record<CategoryName, LegacyDataType>;